import { httpsCallable } from 'firebase/functions'

import {
    ConfirmNewsletterSubscriptionRequest,
    ConfirmNewsletterSubscriptionResponse,
    CreateLeadRequest,
    CreateLeadResponse,
    SubscribeNewsletterRequest,
    SubscribeNewsletterResponse,
} from '@tipi/shared'

import { functions } from './firebase'

const createLeadFn = httpsCallable<CreateLeadRequest, CreateLeadResponse>(functions, 'createLead')

export const createLead = (req: CreateLeadRequest) => createLeadFn(req).then(res => res.data)

const subscribeNewsletterFn = httpsCallable<SubscribeNewsletterRequest, SubscribeNewsletterResponse>(
    functions,
    'subscribeNewsletter',
)

export const subscribeNewsletter = (req: SubscribeNewsletterRequest) =>
    subscribeNewsletterFn(req).then(res => res.data)

const confirmNewsletterSubscriptionFn = httpsCallable<
    ConfirmNewsletterSubscriptionRequest,
    ConfirmNewsletterSubscriptionResponse
>(functions, 'confirmNewsletterSubscription')

export const confirmNewsletterSubscription = (req: ConfirmNewsletterSubscriptionRequest) =>
    confirmNewsletterSubscriptionFn(req).then(res => res.data)
